module.exports = __webpack_public_path__ + "img/footer.dc1cd9c7.png";